const DEFAULT_CONFIG = Object.freeze({
  enabled: false,
  partner: 'adspower',
  locales: ['zh-cn'],
  targetUrl: '',
  placement: 'home_hero_after_cta',
})

function normalizeTargetUrl(value) {
  try {
    const url = new URL(String(value || '').trim())
    return url.protocol === 'https:' ? url.toString() : ''
  } catch (error) {
    return ''
  }
}

export function normalizePartnerAdConfig(config) {
  if (!config || typeof config !== 'object') {
    return { ...DEFAULT_CONFIG }
  }

  const locales = Array.isArray(config.locales)
    ? config.locales.map(locale => String(locale).toLowerCase()).filter(Boolean)
    : DEFAULT_CONFIG.locales
  const targetUrl = normalizeTargetUrl(config.targetUrl || config.target_url)

  return {
    enabled: config.enabled === true && Boolean(targetUrl),
    partner: String(config.partner || DEFAULT_CONFIG.partner),
    locales,
    targetUrl,
    placement: String(config.placement || DEFAULT_CONFIG.placement),
  }
}

export async function loadPartnerAdConfig() {
  const staticUrl = process.env.VUE_APP_PARTNER_AD_STATIC_URL || '/static-config/partner-ad.json'
  const staticUrlNoCache = `${staticUrl}${staticUrl.includes('?') ? '&' : '?'}_ts=${Date.now()}`

  try {
    const response = await fetch(staticUrlNoCache, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    })

    if (response.ok) {
      return normalizePartnerAdConfig(await response.json())
    }
  } catch (error) {
    // Fail closed: a missing or invalid runtime config must not show the ad.
  }

  return { ...DEFAULT_CONFIG }
}
